import { render, staticRenderFns } from "./AuthWidget.vue?vue&type=template&id=d9bded86&"
import script from "./AuthWidget.vue?vue&type=script&lang=js&"
export * from "./AuthWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports